module.exports = __webpack_public_path__ + "img/computer_second_guide.09606975.png";